(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ee-custom-tailoring-button"] && !Shopify.designMode) return;
  try {
    (() => {
  function syncSelection() {
    document.querySelectorAll(".main-product__info").forEach(info => {
      const form = info.querySelector(".product__block-buy_buttons .product__form");
      const picker = info.querySelector("ecx-variant-selects");
      if (!form || !picker) return;
      const options = Array.from(picker.querySelectorAll("select")).map(select => {
        const name = select.name.replace(/^options\[|\]$/g, "");
        return name + ": " + select.value;
      });
      if (!options.length) picker.querySelectorAll("fieldset").forEach(field => {
        const checked = field.querySelector("input:checked");
        if (checked) options.push(checked.value);
      });
      let summary = form.querySelector(".ee-purchase-selection");
      if (!summary) {
        summary = document.createElement("p");
        summary.className = "ee-purchase-selection";
        summary.setAttribute("aria-live", "polite");
        form.prepend(summary);
      }
      const text = options.join(" · ");
      if (summary.textContent !== text) summary.textContent = text;
      summary.hidden = !options.length;
    });
  }
  document.addEventListener("change", event => {
    if (event.target.closest(".main-product__info ecx-variant-selects")) syncSelection();
  });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", syncSelection);
  else syncSelection();
  if (window.eeObserveRegion) window.eeObserveRegion(".main-product__info", syncSelection, 80);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ee-fit-help"] && !Shopify.designMode) return;
  try {
    const EE_FIT_CHARTS = {
  abaya:{sizes:['XS','S','M','L','XL','2XL','3XL','4XL','5XL','6XL','7XL'],fields:{bust:[37,40,43,46,49,53,57,60,63,66,69],waist:[32,35,38,41,44,48,52,55,58,61,64],hips:[39,42,45,48,51,55,59,62,65,68,71]},minHeight:58,maxHeight:74},
  tunic:{sizes:['XS','S','M','L','XL','2XL','3XL','4XL','5XL','6XL','7XL'],fields:{bust:[35,38,41,44,48,51,55,59,63,66,69],waist:[31,34,37,40,44,47,51,55,59,61,64],hips:[37,40,43,46,50,53,57,61,65,68,71]}},
  thobe:{sizes:['XS','S','M','L','XL','2XL','3XL','4XL','5XL','6XL','7XL'],fields:{chest:[36,39,43,46,49,53,56,59,63,65,68],waist:[31,35,38,41,44,47,50,53,56,59,62]},ease:2.5,minHeight:60,maxHeight:74},
  girl_abaya:{sizes:['XS','S','M','L','XL','2XL'],fields:{bust:[24,26,28,30,32,34],waist:[23,25,27,29,31,33],hips:[26,28,30,32,34,36]}},
  girl_top:{sizes:['XS','S','M','L','XL'],fields:{bust:[24,26,28,30,32],waist:[23,25,27,29,31]}},
  boy_top:{sizes:['XS','S','M','L','XL','2XL'],fields:{chest:[25,27,29,31,33,35],waist:[24,26,28,30,32,34]}}
};
function eeFitToken(value){return String(value).split('[')[0].replace(/\s+/g,'').toUpperCase();}
function eeFitCategory(p){
  const title=(p.title+' '+p.handle).toLowerCase(), type=p.type.toLowerCase(), tags=p.tags.map(t=>t.toLowerCase());
  const kid=/\b(kids?|girls?|boys?|child(?:ren)?)\b/.test(title+' '+type)||tags.some(t=>/^(kids?|girls?|boys?)$/.test(t));
  if(/\b(set|sets|khimar|niqab|niqabh|burqa|burkha|maternity)\b/.test(title+' '+type))return null;
  if(kid){
    if(/\bgirls?\b/.test(title+' '+type)||tags.includes('girls'))return /abaya|jilbab/.test(title)?'girl_abaya':/tunic|kurti|shirt|top/.test(title)?'girl_top':null;
    if(/\bboys?\b/.test(title+' '+type)||tags.includes('boys'))return /thobe|dishdash|kurta|shirt|top/.test(title)?'boy_top':null;
    return null;
  }
  if(/thobe|dishdash|jubba/.test(title+' '+type))return 'thobe';
  if(/abaya|jilbab/.test(title+' '+type))return 'abaya';
  if(/\bmens?\b/.test(title)||tags.some(t=>/^(men|mens)$/.test(t)))return null;
  if(/tunic|kurti|jacket|shrug|swimsuit/.test(title+' '+type))return 'tunic';
  return null;
}
function eeFitSize(chart,inputs,offered){
  const keys=Object.keys(chart.fields);
  if(keys.some(k=>!Number.isFinite(inputs[k])||inputs[k]<=0))return {state:'incomplete'};
  const targets=keys.map(k=>inputs[k]+(chart.ease||0));
  if(keys.some((k,j)=>targets[j]<chart.fields[k][0]-3))return {state:'range'};
  const i=chart.sizes.findIndex((s,i)=>keys.every((k,j)=>chart.fields[k][i]>=targets[j]));
  if(i<0)return {state:'range'};
  const value=chart.sizes[i];
  return offered.map(eeFitToken).includes(value)?{state:'match',value}:{state:'missing',value};
}
function eeFitLength(chart,height,offered){
  if(!Number.isFinite(height))return {state:'incomplete'};
  if(!chart.minHeight||height<chart.minHeight-0.25||height>chart.maxHeight+0.25)return {state:'range'};
  const rounded=Math.round(height*10)/10;
  const value=Math.round((Math.max(chart.minHeight,Math.min(chart.maxHeight,rounded))-8)/2)*2;
  const found=offered.find(v=>/^\d+(?:\.\d+)?(?:\s*in(?:ches)?)?$/i.test(String(v).split('[')[0].trim())&&parseFloat(v)===value);
  return found===undefined?{state:'missing',value}:{state:'match',value:found};
}

if(!customElements.get('ee-fit-help'))customElements.define('ee-fit-help',class extends HTMLElement{
  connectedCallback(){
    this.start=()=>this.mount();
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',this.start,{once:true});
    else queueMicrotask(this.start);
  }
  disconnectedCallback(){this.observer?.disconnect();this.dialog?.remove();document.removeEventListener('DOMContentLoaded',this.start);}
  mount(){
    if(this.data)return;
    this.data=JSON.parse(this.querySelector('script').textContent);
    this.root=this.closest('.shopify-section');
    this.picker=this.root?.querySelector('.js-variant-picker');
    if(!this.picker)return;
    this.key=eeFitCategory(this.data);this.chart=EE_FIT_CHARTS[this.key];
    this.attach();
    this.observer=new MutationObserver(()=>this.attach());
    this.observer.observe(this.picker,{childList:true,subtree:true});
  }
  text(k){return this.data.text[k];}
  el(tag,cls,text){const e=document.createElement(tag);e.className=cls||'';if(text!==undefined)e.textContent=text;return e;}
  field(name){return [...this.picker.querySelectorAll('[data-option-name]')].find(e=>e.dataset.optionName.toLowerCase()===name)?.closest('fieldset,.product-form__input');}
  attach(){
    ['size','length'].forEach(name=>{
      const field=this.field(name);if(!field||field.querySelector('[data-ee-fit-trigger]'))return;
      const row=field.querySelector('legend,.product-option__name');if(!row)return;
      const btn=this.el('button','ee-fit-link',this.text(name==='size'?'size_link':'length_link'));
      btn.type='button';btn.dataset.eeFitTrigger=name;btn.setAttribute('aria-haspopup','dialog');
      btn.addEventListener('click',e=>{e.preventDefault();this.open(name,btn);});row.append(btn);
    });
  }
  choices(name){
    const option=this.data.options.find(o=>o.name.toLowerCase()===name);
    return option?.values||[];
  }
  selected(){return this.data.options.map(o=>{
    const field=this.field(o.name.toLowerCase());
    return field?.querySelector('input:checked')?.value||field?.querySelector('select')?.value||null;
  });}
  available(name,value){
    const idx=this.data.options.findIndex(o=>o.name.toLowerCase()===name),selected=this.selected();
    if(!this.data.completeVariants)return null;
    return this.data.variants.some(v=>v.available&&v.options.every((o,i)=>i===idx?eeFitToken(o)===eeFitToken(value):!selected[i]||eeFitToken(o)===eeFitToken(selected[i])));
  }
  apply(name,value){
    if(this.available(name,value)!==true)return false;
    const field=this.field(name);
    const input=[...field.querySelectorAll('input[type=radio]')].find(e=>eeFitToken(e.value)===eeFitToken(value));
    if(input&&!input.disabled){input.click();return true;}
    const select=field.querySelector('select');
    const option=select&&[...select.options].find(o=>eeFitToken(o.value)===eeFitToken(value));
    if(option&&!option.disabled){select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));return true;}
    return false;
  }
  open(name,trigger){
    this.dialog?.remove();
    const d=this.el('dialog','ee-fit-dialog');this.dialog=d;
    const title=this.el('h2','',this.text(name==='size'?'size_title':'length_title'));title.id='ee-fit-title-'+this.data.id;
    d.setAttribute('aria-labelledby',title.id);
    const close=this.el('button','ee-fit-close',this.text('close'));close.type='button';close.addEventListener('click',()=>d.close());
    d.append(close,title,this.el('p','ee-fit-product',this.data.title));
    d.addEventListener('close',()=>{trigger.focus();d.remove();});
    d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();}});
    const chart=this.chart,offered=this.choices(name);
    const standardSize=chart&&offered.some(v=>chart.sizes.includes(eeFitToken(v)));
    const standardLength=chart?.minHeight&&offered.some(v=>/^\d+(?:\.\d+)?(?:\s*in(?:ches)?)?$/i.test(String(v).split('[')[0].trim())&&parseFloat(v)>=chart.minHeight-8&&parseFloat(v)<=chart.maxHeight-8);
    if(!chart||(name==='length'&&!standardLength)||(name==='size'&&!standardSize)){
      d.append(this.el('p','',this.text(name==='length'?'length_manual':'size_manual')));
      d.append(this.el('p','ee-fit-options',this.text('offered')+' '+offered.join(' · ')));
    }else{
      const inputs={},row=this.el('div','ee-fit-fields');
      d.append(this.el('p','ee-fit-explain',this.text(name==='length'?'length_explain':chart.ease?'body_explain':'garment_explain')));
      const units=this.el('select','ee-fit-units');units.setAttribute('aria-label',this.text('units'));
      (name==='length'?[['ft',this.text('feet_inches')],['cm',this.text('cm')]]:[['in',this.text('inches')],['cm',this.text('cm')]]).forEach(([v,t])=>{const o=this.el('option','',t);o.value=v;units.append(o);});
      d.append(units,row);
      const result=this.el('p','ee-fit-result',this.text('enter'));result.setAttribute('role','status');result.setAttribute('aria-live','polite');
      const apply=this.el('button','ee-fit-apply',this.text('apply'));apply.type='button';apply.hidden=true;
      const hint=this.el('p','ee-fit-hint',this.text('estimate'));
      d.append(result,apply,hint);
      let match;
      const update=()=>{
        const values=Object.fromEntries(Object.entries(inputs).map(([k,e])=>[k,e.value===''?NaN:Number(e.value)]));
        if(name==='length'){
          const height=units.value==='cm'?values.cm/2.54:values.feet*12+values.inches;
          match=(units.value==='ft'&&(values.inches<0||values.inches>=12||!Number.isInteger(values.feet)))?{state:'range'}:eeFitLength(chart,height,offered);
        }else{
          if(units.value==='cm')Object.keys(values).forEach(k=>values[k]/=2.54);
          match=eeFitSize(chart,values,offered);
        }
        apply.hidden=true;
        if(match.state==='match'){
          const display=name==='length'?parseFloat(match.value):match.value;
          result.textContent=this.text('suggested')+' '+display+(name==='length'?' '+this.text('inches'):'');
          const available=this.available(name,match.value);
          if(available===true){apply.hidden=false;apply.textContent=this.text('choose')+' '+display;}
          else result.textContent+=' — '+this.text(available===false?'unavailable':'check_option');
        }else result.textContent=this.text(match.state==='incomplete'?'enter':match.state==='missing'?'not_offered':'outside');
      };
      const renderFields=()=>{
        row.replaceChildren();Object.keys(inputs).forEach(k=>delete inputs[k]);
        const keys=name==='length'?(units.value==='cm'?['cm']:['feet','inches']):Object.keys(chart.fields);
        keys.forEach(k=>{
          const label=this.el('label','ee-fit-field',this.text(k));
          const input=this.el('input');input.type='number';input.inputMode='decimal';input.min=k==='inches'&&name==='length'?'0':'1';input.step='0.1';
          if(k==='feet'){input.step='1';input.max='7';}if(k==='inches'&&name==='length')input.max='11.9';
          input.addEventListener('input',update);inputs[k]=input;label.append(input);row.append(label);
        });update();
      };
      units.addEventListener('change',renderFields);renderFields();
      apply.addEventListener('click',()=>{if(match?.state==='match'&&this.apply(name,match.value))d.close();else update();});
    }
    const guide=this.el('a','ee-fit-guide',this.text('full_guide'));guide.href=this.data.guide;guide.target='_blank';guide.rel='noopener';d.append(guide);
    document.body.append(d);d.showModal();
  }
});
  } catch(e) { console.error(e); }
})();

})();
